import { render, staticRenderFns } from "./AutomationList.vue?vue&type=template&id=20773ac7&scoped=true"
import script from "./AutomationList.vue?vue&type=script&lang=js"
export * from "./AutomationList.vue?vue&type=script&lang=js"
import style0 from "./AutomationList.vue?vue&type=style&index=0&id=20773ac7&prod&scoped=true&lang=scss"
import style1 from "./AutomationList.vue?vue&type=style&index=1&id=20773ac7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20773ac7",
  null
  
)

export default component.exports